const STORAGE_KEY = 'ks_language';

export const LANGUAGES = [
  { id: 'english', label: 'English', short: 'EN' },
  { id: 'hindi', label: 'हिंदी', short: 'HI' },
];

export function normalizeLanguage(value) {
  if (!value) return 'english';
  const v = String(value).trim().toLowerCase();
  if (v === 'hindi' || v === 'hi' || v === 'hinglish') return 'hindi';
  return 'english';
}

export function getStoredLanguage() {
  try {
    return normalizeLanguage(localStorage.getItem(STORAGE_KEY));
  } catch {
    return 'english';
  }
}

export function setStoredLanguage(language) {
  const lang = normalizeLanguage(language);
  try {
    localStorage.setItem(STORAGE_KEY, lang);
  } catch {
    /* ignore */
  }
  return lang;
}

/** Append language= to URLSearchParams or object for API calls */
export function withLanguageParam(params = {}, language = getStoredLanguage()) {
  const lang = normalizeLanguage(language);
  if (params instanceof URLSearchParams) {
    params.set('language', lang);
    return params;
  }
  return { ...params, language: lang };
}

export function languageQueryString(language = getStoredLanguage()) {
  return `language=${encodeURIComponent(normalizeLanguage(language))}`;
}
